// extracted by mini-css-extract-plugin
export default {"backOrange":"styles_backOrange__Shz8g","scrollBtnWrap":"styles_scrollBtnWrap__a6kNU","scrollBtn":"styles_scrollBtn__h77c7","rotateAnimation":"styles_rotateAnimation__+aEr3"};